import React, { useState, useEffect } from "react";

import { useParams, useNavigate } from "react-router-dom";

import axios from "axios";

import { toast, ToastContainer } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

import { isMobile } from "react-device-detect";

import { jwtDecode } from "jwt-decode"; // ✅ named import

import { useDispatch } from "react-redux";

import { login } from "./features/Users"; // adjust path if different

const Login = () => {
  const navigate = useNavigate();

  const { id } = useParams();

  const dispatch = useDispatch();

  axios.defaults.baseURL = id;

  const [studentid, setID] = useState(null);

  const [password, setPassword] = useState(null);

  const [status, setStat] = useState(false);

  const [passwordType, setPasswordType] = useState("password");

  const togglePassword = () => {
    if (passwordType === "password") {
      setPasswordType("text");
      return;
    }
    setPasswordType("password");
  };

  const onSubmit_ = (e) => {
    e.preventDefault();

    setStat(true);

    const user = {
      studentid,
      password,
    };

    axios({
      method: "post",
      url: "/v1/",
      data: user,
      config: { headers: { "Content-Type": "multiport/form-data" } },
    })
      .then(function (response) {
        //console.log(response);
        if (response.data.message === "success") {

          const token = response.data.token;
          // Decode the token to extract user data

          const decoded = jwtDecode(token);
          const payload = decoded.data; // ✅ actual user data is inside .data
          console.log("Decoded JWT:", payload);

          // Save the needed fields into Redux
          dispatch(login(payload));

          localStorage.setItem("token", token);
          localStorage.setItem("user", JSON.stringify(payload));

          toast.success("Success: Login successful!", {
            hideProgressBar: true,
            draggable: true,
            position: "top-right",
            icon: true,
            autoClose: 6000,
          });

          setTimeout(() => {
            setStat(false);
            navigate("./home");
          }, 2000);
        }

      })
      .catch((err) => {
        toast.error("Error: Request Failed! Check network connection.");

        setTimeout(function () {
          setStat(false);
        }, 3000);
      });
  };

  const [school, setSchool] = useState([]);

  const [lock, setLock] = useState(false);

  const fetchSchool = () => {
    axios({
      method: "post",
      url: "./v1/school/",
      data: {
        school_id: id,
      },
      config: { headers: { "Content-Type": "multiport/form-data" } },
    })
      .then(function (response) {
        const view = response.data;
        if (view.message !== "failed") {
          setSchool(view);
        } else {
          setLock(true);
        }
      })
      .catch((err) => {
        //toast.error("Error: Request Failed! Refresh page..");
      });
  };

  useEffect(() => {
    fetchSchool();
  }, [id]);

  return (

    <div class="container-fluid bg-back">
      <div class="row align-items-center min-vh-50">

        <div class="col-lg-8 offset-lg-2 col-md-12 col-12">
          <div class="px-lg-16 px-0 mt-8 pt-lg-0">

            <div class="text-center text-dark">
              {id === 'cry' ?
                <div class="fs-t2 fw-medium text-purple2">
                  Crystal View LeadMinds School
                </div>
                :
                <div class="fs-t2 fw-medium text-purple2">
                  {school.schoolname} School
                </div>
              }
            </div>

            <div className="card shadow-none mt-5 mb-5 py-lg-4 px-lg-8 py-6 px-4" style={{ borderRadius: "26px" }}>
              <div class="text-dark mt-3 mb-3">

                <form className="text-center" onSubmit={onSubmit_}>

                  <div class="fs-t">
                    Welcome Back{" "}
                    <span className="text-success">
                      Champ!
                    </span>
                  </div>

                  <div className="mt-2 fs-4 text-purple2 mb-5">
                    Fill in your details below to access App.
                  </div>

                  <div class="mb-6">
                    <input
                      type="text"
                      maxLength={10}
                      id="name-input"
                      autoComplete={false}
                      name="admin"
                      class="form-control form-control-lg text-dark fs-3 bg-back rounded-pill"
                      placeholder="Student ID"
                      required
                      onChange={(e) => setID(e.target.value)}
                    />
                  </div>

                  <div class="mb-6 mb-lg-6">
                    <div class="d-flex align-items-center">
                      <input
                        type={passwordType}
                        class="form-control form-control-lg text-dark fs-3 bg-back rounded-pill"
                        placeholder="Type in your password"
                        required
                        onChange={(e) =>
                          setPassword(e.target.value)
                        }
                      />
                    </div>
                  </div>


                  <div class={isMobile ? "fixed-bottom card p-3" : ''}>
                    <div className="d-grid px-1">
                      <button
                        className="btn btn-lg btn-purple rounded-4 shadow-lg"
                        type="submit"
                        disabled={status ? true : false}
                      >
                        {status ? (
                          <>
                            Executing...
                            <span
                              class="spinner-border spinner-border-sm ms-3"
                              role="status"
                              aria-hidden="true"
                            ></span>
                          </>
                        ) : (
                          "Login To Dashboard"
                        )}
                      </button>
                    </div>
                  </div>

                  <div class="mt-6">

                    <div className="">
                      <div className="">
                        <div className="col-auto">
                          <div class="mb-2">
                            <img
                              src="../assets/smlogo.png"
                              width={isMobile ? "76" : "80"}
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="text-purple2 fs-4">
                      © 2022 Powered and developed with ❤️.
                      All rights reserved
                    </div>

                  </div>

                </form>

              </div>

            </div>

          </div>



        </div>
      </div>

      <ToastContainer />
    </div>

  );
};

export default Login;
